import { ACTIONS } from 'actions/question-insights';

const initialState = [];

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.PUSH_INSIGHTS_DATA:
      return payload && Object.keys(payload) && Object.keys(payload).length
        ? [...state, payload]
        : [...state];
    case ACTIONS.UPDATE_INSIGHTS_DATA:
      return [...payload];
    default:
      return state;
  }
}
